import InlineEditors from '../../controllers/inlineEditors';
import Overdue from '../../chart/overdue';
import MassSelect from '../../controllers/massSelect';

/**
 * Specifies the CSS class that will be applied to a grid row
 * @param instance
 * @returns {(function(*, *, *): (string|string))|*}
 */
export default instance => (start, end, task) => {
  const classes = ['gantt_row'];

  const isButtonTask = task.type === instance.config.types.button;
  const taskIdNumber = +task.id;

  if (instance.config.readonly) {
    classes.push('unuseble');
  }

  if (isButtonTask) {
    classes.push('gantt_btn_add');
  }

  if (task.$index % 2 !== 0) {
    classes.push('odd');
  }

  if (task.$transparent) {
    classes.push('gantt_transparent');
  }

  if (instance.isSelectedTask(taskIdNumber) || +instance.getState().selected_task === taskIdNumber) {
    classes.push('gantt_selected');
  }

  if (InlineEditors.isActive()) {
    if (isButtonTask && InlineEditors.getState().id === task.id) {
      classes.push('active');
    }

    if (!isButtonTask && +InlineEditors.getState().id === taskIdNumber) {
      classes.push('gantt_row_editing');
    }
  }

  if (+instance.config._opened_task_id === taskIdNumber) {
    classes.push('selected');
  }

  if (task.$level === 0) {
    classes.push('estimate_total');
  } else if (task.$level === 1 || (task.$level === 2 && isButtonTask && instance.config.multiview)) {
    classes.push(task.type === 'project' ? 'top_project' : 'top_task');
  } else if (task.type !== 'task' && task.type !== 'milestone') {
    classes.push('task_group');
  }

  if (Overdue.checkIsOverdue(task) && instance.config.highlight_overdue) {
    classes.push('highlightOverdueGrid');
  }

  if (instance.ganttDataApi.isMassChangeEnabled()) {
    const isAttachmentsColumn = instance.config.columns.find(col => col.name === 'attachments');
    const isCommentsColumn = instance.config.columns.find(col => col.name === 'comments');
    const isOverloadColumn = instance.config.columns.find(col => col.name === 'overload');
    let masschangePaddingClass = '';

    if (isAttachmentsColumn.hide && isCommentsColumn.hide && isOverloadColumn.hide) {
      masschangePaddingClass = 'masschange_disabled_left_padding_20';
    } else if (!isOverloadColumn.hide && isAttachmentsColumn.hide && isAttachmentsColumn.hide) {
      masschangePaddingClass = 'masschange_disabled_left_padding_10';
    }

    classes.push('masschange_disabled', masschangePaddingClass);

    if (MassSelect.isTaskSelected(task.id)) {
      classes.push('gantt-task-mc-selected');
    }
  }

  if (task.needMultiviewBackground) {
    classes.push('multiviewBackground');
  }

  // if (instance.config.dnd_task_temp && instance.config.dnd_task_temp[task.id]) {
  //   classes.push('dnd-highlight-paste');
  // }

  // if (task.highlight) {
  //   classes.push('gantt_line__highlight');
  // }

  if (task.$level > 6) {
    classes.push('leaf-task');
  }

  // if (+task.id === +instance.$grid_dnd) {
  //   classes.push('dnd-task');
  // }

  if (task.id === instance._currentHoverRowId) {
    classes.push('row_hover');
  }

  return classes.join(' ');
};
